import React from 'react';
import { AlertTriangle, Heart, Shield, Clock, BookOpen, Smile } from 'lucide-react';

const ProblemSolution = () => {
  const problems = [
    { icon: <AlertTriangle className="w-6 h-6" />, text: 'Stress and anxiety' },
    { icon: <Heart className="w-6 h-6" />, text: 'Lack of guidance' },
    { icon: <Clock className="w-6 h-6" />, text: 'No time for spiritual learning' },
    { icon: <AlertTriangle className="w-6 h-6" />, text: 'Confusion in beliefs' }
  ];

  const solutions = [
    { icon: <Heart className="w-6 h-6" />, text: 'Talk to Bhagwan anytime' },
    { icon: <BookOpen className="w-6 h-6" />, text: 'Receive guidance rooted in scriptures' },
    { icon: <Smile className="w-6 h-6" />, text: 'Build a daily spiritual habit' },
    { icon: <Shield className="w-6 h-6" />, text: 'A safe, judgment-free space' }
  ];

  return (
    <section className="py-20 relative">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start max-w-6xl mx-auto">
          {/* Problems */}
          <div className="flex flex-col">
            <h3 className="font-serif text-3xl lg:text-4xl font-bold mb-8 text-red-300 min-h-[80px] flex items-center">
              Modern Life Feels Disconnected
            </h3>
            <div className="space-y-6 flex-1">
              {problems.map((problem, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 bg-red-500/10 border border-red-500/20 rounded-xl backdrop-blur-sm min-h-[72px]"
                >
                  <div className="text-red-400 flex-shrink-0">
                    {problem.icon}
                  </div>
                  <span className="text-gray-300">{problem.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Solutions */}
          <div className="flex flex-col">
            <h3 className="font-serif text-3xl lg:text-4xl font-bold mb-8 text-white min-h-[80px] flex items-center">
              With <span className="text-gradient ml-2">ShraddhaAI</span>
            </h3>
            <div className="space-y-6 flex-1">
              {solutions.map((solution, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 bg-orange-500/10 border border-orange-500/20 rounded-xl backdrop-blur-sm min-h-[72px]"
                >
                  <div className="text-orange-500 flex-shrink-0">
                    {solution.icon}
                  </div>
                  <span className="text-gray-100">{solution.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;